import RelatedContentSection from "./RelatedContentSection";

export default RelatedContentSection;
